<div class="grid-view-main-container">
  <div class="table-container">
    <table class="table" *ngIf="data">
      <thead class="thead-dark sticky-top table-head">
        <tr>
          <th class="column-selector-container" *ngIf="showColumnSelector">
            <div (click)="openColumnOptions($event)">
              <ion-icon name="caret-down-circle-outline"
                class="table-header-select ion-no-padding align-middle"></ion-icon>
            </div>
          </th>
          <th class="column-selector-container px-0 ps-1" *ngIf="multiSelectProperty">
            <div class="px-0">
              <input type="checkbox" class="align-middle" [checked]="isAllSelected()"
                (change)="toggleSelectAllRows($event)">
            </div>
          </th>
          <!-- Freeze columns should impact here -->
          <th *ngFor="let head of initialColumns; let i = index" [ngClass]="getTHColumnClasses(head.cssClass, i)">
            <div class="table-heading">
              <p class="text mb-0">{{ head.colName }}</p>
              <ng-container *ngIf="head?.sortColumn">
                <button class="sort-btn" (click)="sortData(head.key)" *ngIf="!hideSortBtn">
                  <ion-icon
                    [name]="sortOrder[head.key] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                </button>
              </ng-container>
            </div>
          </th>
          <th class="phone-number-column" *ngIf="showStatusDropdown">
            <div class="table-heading">Status</div>
          </th>
          <th class="phone-number-column" *ngIf="showToggleBtn">
            <div class="table-heading">Status</div>
          </th>
          <th *ngIf="optionsValues" class="options-column">
            <div class="table-heading border-0">Options</div>
          </th>
        </tr>
      </thead>
      <tbody class="table-body">
        <tr *ngFor="let row of data">
          <td *ngIf="showColumnSelector"></td>
          <td *ngIf="multiSelectProperty" class="px-0">
            <div class="px-0 ps-1">
              <input type="checkbox" class="align-middle" [checked]="isRowSelected(row)"
                (change)="toggleSelectRow($event, row)">
            </div>
          </td>

          <!-- Freeze columns should add classes here also -->
          <td *ngFor="let head of initialColumns; let i = index"
            (click)="head.emitRowOnClick ? onCellClick(row, head.key) : null" [ngClass]="getTDColumnClasses(i)">

            <ng-container *ngIf="head.routePath; else noRoute">
              <ng-container *ngIf="row[head.key] && row[head.key] !== 0; else noData">

                <p routerLink="{{ head.routePath }}{{ row[head.key] }}" class="mb-0 clickable-text">
                  {{ row[head.key] | applyFormatter: head.formatter }}
                </p>
              </ng-container>
            </ng-container>
            <ng-template #noRoute>
              <ng-container *ngIf="row[head.key] || row[head.key] === 0 || row[head.key] === false; else noData">
                <div class="d-flex align-items-center">
                  <p class="mb-0" [ngClass]="{'clickable-text': head.emitRowOnClick}">
                    <ng-container *ngIf="head.formatter === 'toggle'; else normalText">
                      <span
                        [title]="head.isToggleDisabled && head.isToggleDisabled(row)  ? (head.toggleDisabledTooltip ? head.toggleDisabledTooltip(row) : 'Cannot change this user\'s status')  : ''"
                        (click)="$event.stopPropagation()">
                        <ion-toggle [checked]="row[head.key]"
                          [disabled]="head.isToggleDisabled && head.isToggleDisabled(row)" (ionChange)="triggerToggleChange.emit({
                          row: row,
                          isActive: $event.detail.checked
                           })">
                        </ion-toggle>
                      </span>
                    </ng-container>
                    <ng-template #normalText>
                      <span *ngIf="head.type == 'personName'">
                        <button class="person-name-badge">{{row.personNameBadge}}</button>
                      </span>
                      <span *ngIf="head.type == 'locationIcon' && row[head.key]">
                        <ion-button class="location-icon">
                          <ion-icon name="pin-outline"></ion-icon>
                        </ion-button>
                      </span>

                      <span *ngIf="head.type == 'phoneNumber' && row[head.key]">
                        <ion-button class="phone-icon" (click)="emitCallActionTrigger.emit(row)">
                          <ion-icon name="call-outline"></ion-icon>
                        </ion-button>
                      </span>

                      <div *ngIf="head.type == 'sourceImage'" style="display: flex; gap: 8px; flex-wrap: wrap;">
                        <ng-container *ngIf="row.sourceImages?.length">
                          <div *ngFor="let image of row.sourceImages" class="source-image-document"
                            (click)="openSourceImage(image); $event.stopPropagation()">
                            <ion-icon name="document-text-outline"></ion-icon>
                            <span>Source Image</span>
                          </div>
                        </ng-container>

                        <!-- Backward compatibility -->
                        <div *ngIf="(!row.sourceImages || row.sourceImages.length === 0) && row.sourceImage"
                          class="source-image-document"
                          (click)="openSourceImage(row.sourceImage); $event.stopPropagation()">
                          <ion-icon name="document-text-outline"></ion-icon>
                          <span>Source Image</span>
                        </div>
                      </div>

                      <span *ngIf="head.type != 'sourceImage'">
                        {{ row[head.key] | applyFormatter: head.formatter }}
                      </span>
                    </ng-template>
                  </p>
                </div>
              </ng-container>
            </ng-template>
            <ng-template #noData>
              <p class="mb-0">--</p>
            </ng-template>
          </td>

          <!-- Status dropdown input -->
          <td *ngIf="showStatusDropdown">
            <div class="status-container">
              <select class="input-status status-dropdown" [ngModel]="row.status" (change)="statusChanged($event, row)"
 [class]="getStatusColor(row.status)">
                <option *ngFor="let status of row.statusLov" [ngClass]="{'d-none': status.disabled}"
                  [value]="status.key">{{status.name}}</option>
              </select>
            </div>
          </td>

          <!-- Toggel button -->
          <td *ngIf="showToggleBtn">
            <div class="toggle-container d-flex align-items-center">
              <ion-toggle class="toggle-btn" [ngModel]="row.status" (ngModelChange)="onToggleChange($event, row)">

              </ion-toggle>
              <span class="ml-2">{{ row.status ? 'Active' : 'Inactive' }}</span>
            </div>
          </td>

          <td *ngIf="optionsValues">
            <div class="table-options-main-container">
              <div class="action-button-container" *ngIf="showWhatsappActionBtn">
                <ion-button class="action-btn whatsapp-btn" (click)="emitWhatsappActionTrigger.emit(row)">
                  <ion-icon name="logo-whatsapp"></ion-icon>
                </ion-button>
              </div>
              <div class="action-button-container" *ngIf="showEmailActionBtn">
                <ion-button class="action-btn email-btn" (click)="emitEmailActionTrigger.emit(row)">
                  <ion-icon name="mail-outline"></ion-icon>
                </ion-button>
              </div>
              <div class="options text-center" (click)="showOptions($event, row)">
                <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
              </div>
            </div>

          </td>
        </tr>
        <tr *ngIf="data.length === 0">
          <td [attr.colspan]="getfullColSpan()" class="text-center py-3">No Results Found!</td>
        </tr>


      </tbody>
    </table>
  </div>



  <div class="w-100 paginations-container" *ngIf="!hidePaginations && !hidePaginationHard && paginationSettings">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <div class="select-container">
          <select name="" id="" class="records-selector" [(ngModel)]="paginationSettings.pageSize"
            (change)="onPageSizeChange()">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
        <div class="label-container">
          <p class="label">Showing {{noOfRows}} records of {{paginationSettings?.totalCount}}</p>
        </div>
      </div>

      <div class="control-btns">
        <div class="buttons-row">
          <!-- Back btn -->
          <ion-button class="control-btn" (click)="onPrevious()" [disabled]="paginationSettings?.pageNumber === 1">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>

          <!-- pages buttons list -->
          <ion-button class="control-btn" *ngFor="let page of visiblePages" (click)="onPageChange(page)"
            [class.active]="page === paginationSettings?.pageNumber">
            {{page}}
          </ion-button>

          <!-- Forward btn -->
          <ion-button class="control-btn" (click)="onNext()"
            [disabled]="paginationSettings?.pageNumber === paginationSettings?.totalPages">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</div>